/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 4g62i_yC4jmZ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { DialogClose } from "@plasmicpkgs/radix-ui";
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicContactModalMessageSent.module.css"; // plasmic-import: 4g62i_yC4jmZ/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicContactModalMessageSent__VariantMembers = {};
export type PlasmicContactModalMessageSent__VariantsArgs = {};
type VariantPropType = keyof PlasmicContactModalMessageSent__VariantsArgs;
export const PlasmicContactModalMessageSent__VariantProps =
  new Array<VariantPropType>();

export type PlasmicContactModalMessageSent__ArgsType = { onClose?: () => void };
type ArgPropType = keyof PlasmicContactModalMessageSent__ArgsType;
export const PlasmicContactModalMessageSent__ArgProps = new Array<ArgPropType>(
  "onClose"
);

export type PlasmicContactModalMessageSent__OverridesType = {
  messageSentModal?: Flex__<"div">;
  fill2?: Flex__<"div">;
  icon?: Flex__<typeof PlasmicImg__>;
  text2?: Flex__<"div">;
  dialogClose?: Flex__<typeof DialogClose>;
  button?: Flex__<typeof Button>;
};

export interface DefaultContactModalMessageSentProps {
  onClose?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicContactModalMessageSent__RenderFunc(props: {
  variants: PlasmicContactModalMessageSent__VariantsArgs;
  args: PlasmicContactModalMessageSent__ArgsType;
  overrides: PlasmicContactModalMessageSent__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"messageSentModal"}
      data-plasmic-override={overrides.messageSentModal}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.messageSentModal
      )}
    >
      <div
        data-plasmic-name={"fill2"}
        data-plasmic-override={overrides.fill2}
        className={classNames("all", sty.fill2)}
      >
        <PlasmicImg__
          data-plasmic-name={"icon"}
          data-plasmic-override={overrides.icon}
          alt={""}
          className={classNames(sty.icon)}
          displayHeight={"48px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"68px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/e50de53e36275ee0d1b58ba4a67ca187.svg",
            fullWidth: 60,
            fullHeight: 48,
            aspectRatio: 1.25
          }}
        />

        <div
          data-plasmic-name={"text2"}
          data-plasmic-override={overrides.text2}
          className={classNames("all", sty.text2)}
        >
          <h2
            className={classNames(
              "all",
              "h2",
              "h2__bvRZj",
              "__wab_text",
              sty.h2__o6Lo0
            )}
          >
            {"Message Sent"}
          </h2>
          <h2
            className={classNames(
              "all",
              "h2",
              "h2__bvRZj",
              "__wab_text",
              sty.h2__aJ2U8
            )}
          >
            {
              "Expect a prompt reply via phone or email. Sales requests within a business day; critical issues within 3 hours."
            }
          </h2>
        </div>
      </div>
      <DialogClose
        data-plasmic-name={"dialogClose"}
        data-plasmic-override={overrides.dialogClose}
        className={classNames("__wab_instance", sty.dialogClose)}
      >
        <Button
          data-plasmic-name={"button"}
          data-plasmic-override={overrides.button}
          className={classNames("__wab_instance", sty.button)}
          color={"white"}
          onClick={async event => {
            const $steps = {};

            $steps["runOnClose"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onClose"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnClose"] != null &&
              typeof $steps["runOnClose"] === "object" &&
              typeof $steps["runOnClose"].then === "function"
            ) {
              $steps["runOnClose"] = await $steps["runOnClose"];
            }
          }}
          size={"large"}
        >
          {"CLOSE"}
        </Button>
      </DialogClose>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  messageSentModal: [
    "messageSentModal",
    "fill2",
    "icon",
    "text2",
    "dialogClose",
    "button"
  ],
  fill2: ["fill2", "icon", "text2"],
  icon: ["icon"],
  text2: ["text2"],
  dialogClose: ["dialogClose", "button"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  messageSentModal: "div";
  fill2: "div";
  icon: typeof PlasmicImg__;
  text2: "div";
  dialogClose: typeof DialogClose;
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicContactModalMessageSent__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicContactModalMessageSent__VariantsArgs;
    args?: PlasmicContactModalMessageSent__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicContactModalMessageSent__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicContactModalMessageSent__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContactModalMessageSent__ArgProps,
          internalVariantPropNames: PlasmicContactModalMessageSent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContactModalMessageSent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "messageSentModal") {
    func.displayName = "PlasmicContactModalMessageSent";
  } else {
    func.displayName = `PlasmicContactModalMessageSent.${nodeName}`;
  }
  return func;
}

export const PlasmicContactModalMessageSent = Object.assign(
  // Top-level PlasmicContactModalMessageSent renders the root element
  makeNodeComponent("messageSentModal"),
  {
    // Helper components rendering sub-elements
    fill2: makeNodeComponent("fill2"),
    icon: makeNodeComponent("icon"),
    text2: makeNodeComponent("text2"),
    dialogClose: makeNodeComponent("dialogClose"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicContactModalMessageSent
    internalVariantProps: PlasmicContactModalMessageSent__VariantProps,
    internalArgProps: PlasmicContactModalMessageSent__ArgProps
  }
);

export default PlasmicContactModalMessageSent;
/* prettier-ignore-end */
